import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

// Settable from URL query parameters — "this is how you do static prefill links"
// (docs/01-PRODUCT-SPEC.md §3.2).
const configSchema = z.object({
  queryParameter: z.string().min(1).max(60).default("ref"),
  defaultValue: z.string().max(500).default(""),
});

export const hiddenField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "hidden",
  label: "Hidden value",
  category: "system",
  icon: "EyeOff",
  configSchema,
  valueSchema: (_config, isRequired) => optionalUnlessRequired(z.string().max(500), isRequired),
  defaultConfig: { queryParameter: "ref", defaultValue: "" },
  supportsProfileBinding: false,
  defaultSearchable: true,
  renderHints: { isHiddenFromApplicant: true },
};
